import React from 'react';
import PropTypes from 'prop-types';
import Modal from '../../controls/Modal';
import { useConfirmationModalStore } from '../../../../../stores';
import { RefreshIcon } from '../../../model/icons';
import TeamCard from './TeamCard';

// Модалка «Команды»: список команд игры + обновление из Camp Service + исключение команды.
export default function TeamsModal({ teams, onRefresh, onDelete, onClose }) {
    const { open: openConfirm } = useConfirmationModalStore();

    const handleDelete = (team) => openConfirm(
        <div className="confirm-msg">
            <b>Убрать команду из игры?</b>
            <p>Команда «{team.name}» будет исключена из «Ставок». Её ставки и события останутся в истории.</p>
        </div>,
        async () => { await onDelete(team.id); },
        { confirmText: 'Убрать' }
    );

    return (
        <Modal
            open
            kicker="Ставки"
            title="Команды"
            size="lg"
            onClose={onClose}
            footer={<button type="button" className="btn btn-ghost" onClick={onClose}>Закрыть</button>}
        >
            <div className="ev-head">
                <h2>Список команд <span className="fr-cnt">({teams.length})</span></h2>
                <button type="button" className="btn btn-ghost" onClick={onRefresh}>
                    <span className="ic"><RefreshIcon /></span>Обновить команды
                </button>
            </div>
            {teams.length > 0 ? (
                <div className="bt-teams">
                    {teams.map(team => <TeamCard key={team.id} team={team} onDelete={handleDelete} />)}
                </div>
            ) : <div className="bt-empty">Нет команд — нажмите «Обновить команды»</div>}
        </Modal>
    );
}

TeamsModal.propTypes = {
    teams: PropTypes.array.isRequired,
    onRefresh: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired
};
